module.exports = __webpack_public_path__ + "static/img/pic-01@2x.50f6cf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/pic-01@2x.png
// module id = AaAd
// module chunks = 1